import React, { useContext, useState, useEffect } from "react";
import schoolApi from "../../api/schoolApi";
import { Col, Form, Row, Card } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { SessionContext } from "../SessionProvider";

const Transport = () => {
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
  const [transport, setTransport] = useState(null);
  const [selectedStudent, setStudent] = useOutletContext();

  useEffect(() => {
    async function fetchData() {
      console.log("Selected-Student-transport-->>", selectedStudent);

      if ( selectedStudent?.addmission_id || selectedStudent?.student_addmission_id) {
        try {
          // const id = selectedStudent.addmission_id || selectedStudent.student_addmission_id;
          const studentId = selectedStudent.id;
          const response = await schoolApi.getAssignTransportByIdOrStudentid(studentId , selectedSessionId);
          
          if (response && response.result && response?.result?.status) {
            setTransport(response.result);
          } else {
            setTransport(null);
          }
        } catch (error) {
          toast.error("Failed to fetch transport data. Please try again.");
          console.error("Error fetching transport data:", error);
        }
      }
    }

    fetchData();
  }, [selectedStudent , selectedSessionId]);

  return (
    <>
      <Card className="mx-3 my-4" style={{ minHeight: "500px" }}>
        <Card.Header
          className="text-center font-weight-bold"
          style={{ fontSize: "1.2rem" }}
        >
          Transport Details
        </Card.Header>
        {transport ? (
          <Card.Body>
            <Row className="mb-3">
              <Col>
                <Form.Label className="labelheading">Driver Name:</Form.Label>
                <span className="value-text">{transport.driver_name}</span>
              </Col>
              <Col>
                <Form.Label className="labelheading">Drop Location:</Form.Label>
                <span className="value-text">{transport.drop_location}</span>
              </Col>
              <Col>
                <Form.Label className="labelheading">Fare Amount:</Form.Label>
                <span className="value-text">{transport.fare_amount}</span>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Label className="labelheading">
                  Route Direction:
                </Form.Label>
                <span className="value-text">{transport.route_direction}</span>
              </Col>
              <Col>
                <Form.Label className="labelheading">
                  Seating Capacity:
                </Form.Label>
                <span className="value-text">{transport.seating_capacity}</span>
              </Col>
              <Col>
                <Form.Label className="labelheading">Location Name:</Form.Label>
                <span className="value-text">{transport.location_name}</span>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={4}>
                <Form.Label className="labelheading">Type:</Form.Label>
                <span className="value-text">{transport.type}</span>
              </Col>
              <Col lg={4}>
                <Form.Label className="labelheading">Vehicle No:</Form.Label>
                <span className="value-text">{transport.vehicle_no}</span>
              </Col>
            </Row>
          </Card.Body>
        ) : (
          <div className="text-center mt-3">
            <p className="text-muted">No Records Found</p>
          </div>
        )}
      </Card>
    </>
  );
};

export default Transport;
